//@flow
import * as Immutable from 'immutable';
import ImmutableModel from './ImmutableModel'; // Make sure you copied this file into your repo
import type { BeatVisit } from './BeatVisit';

export type FpPointsLatLngModelType = {
    lat: number,
    lng: number
};

export type FpBeatModelType = {
    beatDay: {
        dayOfWeek: string,
        week: string
    },
    beatId: string,
    name: string,
    categories: Array<string>,
    currentSalesmanId: string,
    hasFrozenVisits: boolean,
    isEdited: boolean,
    lastEditedOn: ?string,
    visits: Array<BeatVisit>,
    summary: {
        totalTravelDistance: number,
        totalTravelDuration: number,
        totalTransactionDuration: number,
        totalDuration: number,
        visitCount: number,
        serviceabilityRatio: number,
        outerPolygon: {
            points: Array<FpPointsLatLngModelType>
        }
    }
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class FpPointsLatLng extends ImmutableModel {
    static fromJS(json: FpPointsLatLngModelType): FpPointsLatLng {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    toJS(): FpPointsLatLngModelType {
        return {
            lat: this.lat,
            lng: this.lng
        };
    }

    get lat(): number {
        return this._state.get('lat');
    }

    setLat(lat: number): this {
        return this.clone(this._state.set('lat', lat));
    }

    get lng(): number {
        return this._state.get('lng');
    }

    setLng(lng: number): this {
        return this.clone(this._state.set('lng', lng));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class FpBeat extends ImmutableModel {
    static fromJS(json: FpBeatModelType): FpBeat {
        const state: Object = Object.assign({}, json);
        state.categories = Immutable.List(state.categories);
        state.visits = Immutable.List(state.visits);
        return new this(Immutable.Map(state));
    }

    toJS(): FpBeatModelType {
        return {
            beatDay: this.beatDay,
            beatId: this.beatId,
            name: this.name,
            categories: this.categories.toArray(),
            currentSalesmanId: this.currentSalesmanId,
            hasFrozenVisits: this.hasFrozenVisits,
            isEdited: this.isEdited,
            lastEditedOn: this.lastEditedOn,
            visits: this.visits.toArray(),
            summary: this.summary
        };
    }

    get beatDay(): {
        dayOfWeek: string,
        week: string
    } {
        return this._state.get('beatDay');
    }

    setBeatDay(beatDay: { dayOfWeek: string, week: string }): this {
        return this.clone(this._state.set('beatDay', beatDay));
    }

    get beatId(): string {
        return this._state.get('beatId');
    }

    setBeatId(beatId: string): this {
        return this.clone(this._state.set('beatId', beatId));
    }

    get name(): string {
        return this._state.get('name');
    }

    setName(name: string): this {
        return this.clone(this._state.set('name', name));
    }

    get categories(): Immutable.List<string> {
        return this._state.get('categories');
    }

    setCategories(categories: Immutable.List<string>): this {
        return this.clone(this._state.set('categories', categories));
    }

    get currentSalesmanId(): string {
        return this._state.get('currentSalesmanId');
    }

    setCurrentSalesmanId(currentSalesmanId: string): this {
        return this.clone(
            this._state.set('currentSalesmanId', currentSalesmanId)
        );
    }

    get hasFrozenVisits(): boolean {
        return this._state.get('hasFrozenVisits');
    }

    setHasFrozenVisits(hasFrozenVisits: boolean): this {
        return this.clone(this._state.set('hasFrozenVisits', hasFrozenVisits));
    }

    get isEdited(): boolean {
        return this._state.get('isEdited');
    }

    setIsEdited(isEdited: boolean): this {
        return this.clone(this._state.set('isEdited', isEdited));
    }

    get lastEditedOn(): ?string {
        return this._state.get('lastEditedOn');
    }

    setLastEditedOn(lastEditedOn: ?string): this {
        return this.clone(this._state.set('lastEditedOn', lastEditedOn));
    }

    get visits(): Immutable.List<BeatVisit> {
        return this._state.get('visits');
    }

    setVisits(visits: Immutable.List<BeatVisit>): this {
        return this.clone(this._state.set('visits', visits));
    }

    get summary(): {
        totalTravelDistance: number,
        totalTravelDuration: number,
        totalTransactionDuration: number,
        totalDuration: number,
        visitCount: number,
        serviceabilityRatio: number,
        outerPolygon: { points: Array<FpPointsLatLngModelType> }
    } {
        return this._state.get('summary');
    }

    setSummary(summary: {
        totalTravelDistance: number,
        totalTravelDuration: number,
        totalTransactionDuration: number,
        totalDuration: number,
        visitCount: number,
        serviceabilityRatio: number,
        outerPolygon: { points: Array<FpPointsLatLngModelType> }
    }): this {
        return this.clone(this._state.set('summary', summary));
    }
}
